var HyperLinkSupport = require("enyo-ui/HyperLinkSupport"),
    IconButton       = require("app/ui/IconButton"),
    frameThrottle    = require("enyo-perf/utils").frameThrottle,
    icons            = require("app/theme/icons"),
    kind             = require("enyo/kind"),
    onHyperlinkTap   = require("app/utils/onHyperlinkTap"),
    quickMacroize    = require("enyo/macroize").quickMacroize;

require("app/theme/IconButton--neutral.less");

module.exports = kind(/** @lends  app.Auth.ProfileButton.prototype */ {

    /**
     * @private
     */
    name: "app.Auth.ProfileButton",

    /**
     * @private
     */
    kind: IconButton,

    /**
     * @private
     */
    classes: "app-auth-profile-button",

    /**
     * @private
     */
    mixins: [
        HyperLinkSupport
    ],

    /**
     * The theme to use for this button.
     *
     * @type  {?string}
     * @public
     */
    theme: "neutral",

    /**
     * The id used to reference an icon from the icon-sprite.
     *
     * @type  {?string}
     * @public
     */
    icon: icons["app.Auth.ProfileButton"],

    /**
     * Align the icon on the left or the right.
     *
     * @type  {?string}
     * @public
     */
    iconAlignment: "left",

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);

            // Update content
            this.observe("app.$.i18nService.translation", this.update);
            this.update();
        };
    }),

    /**
     * @protected
     */
    update: function() {
        var i18nService = this.app.$.i18nService;

        this.set("caption", i18nService.getString("app.Auth.ProfileButton.caption"));
        this.set("tooltip", i18nService.getString("app.Auth.ProfileButton.tooltip"));
        this.set("href", quickMacroize("/{$language}/profile", {
            language: i18nService.get("language")
        }));
    },

    /**
     * Determine whether this button should show.
     *
     * @return  {boolean}  Whether this button should be visible
     */
    shouldShow: function() {
        var authService = this.app.$.authService;

        switch (authService.isLoggedIn) {
            case 1:
                return true;
            case 0:
            case -1:
            default:
                return false;
        }
    },

    /**
     * Instruct the router to navigate to the new location
     *
     * @return  {boolean}  Stop propagation
     * @private
     */
    tap: function() {
        onHyperlinkTap.call(this, this);

        // Always propagate so that parent menu can respond and close itself
        return false;
    }

});
